<template>
  <div class="flex flex-direction align-center" ref="container">
    <MenuHeader></MenuHeader>
    <div
      class="scroll-y"
      :style="
        `width: 100vw;height: calc(100vh - ${UI.isMobile ? '50' : '70'}px)`
      "
    >
      <div ref="body" class="full-width"><router-view></router-view></div>
      <Footer v-if="noFooterList.indexOf($router.name) < 0"></Footer>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import MenuHeader from '@/components/menuHeader.vue';
import Footer from '@/components/footer.vue';

export default {
  components: {
    MenuHeader,
    Footer,
  },

  computed: {
    ...mapState(['User', 'UI']),
  },

  data() {
    return {
      noFooterList: [
        'info',
        'login',
        'registry',
        'changepwd',
        'organizationapprove',
        'userinfoapprove',
      ],
    };
  },
};
</script>

<style lang="scss">
$container-width: 80%;

@media screen and (min-width: 1000px) {
  .container {
    width: $container-width;
    margin-left: 10%;
  }

  .min-body-height {
    min-height: calc(100vh - 350px);
    padding-bottom: 50px;
  }

  .info-container {
    width: 80%;
    margin-left: 10%;
    margin-top: 2%;
  }
}

@media screen and (max-width: 1000px) {
  .container {
    width: 100%;
  }

  .min-body-height {
    min-height: calc(100vh - 350px);
    padding-bottom: 30px;
  }

  .info-container {
    border-radius: 0;
  }
}

.header-container {
  width: $container-width;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue